<template>
  <div class="layout hvf-multi-image-block"
    @wheel.prevent="wheel"
    @keydown.up.prevent="$emit('scrollUp')"
    @keydown.down.prevent="$emit('scrollDown')"
    @keydown.right.prevent="$emit('next', index)"
    @keydown.left.prevent="$emit('prev', index)">
    <v-flex hvf-image-view-wrapper 
      xs6
      :order-xs1="hvfOrder"
      :order-xs2="!hvfOrder">
      <hvfImageView 
        eye="OS"
        :image="hvfOSImage"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @hvf_mousedown="$emit('hvf_mousedown', $event)"
        @hvf_mousemove="$emit('hvf_mousemove', $event)"
        @hvf_mouseup="$emit('hvf_mouseup', $event)"/>
    </v-flex>
    <v-flex hvf-image-view-wrapper 
      xs6
      :order-xs1="!hvfOrder"
      :order-xs2="hvfOrder">
      <hvfImageView 
        eye="OD"
        :image="hvfODImage"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @hvf_mousedown="$emit('hvf_mousedown', $event)"
        @hvf_mousemove="$emit('hvf_mousemove', $event)"
        @hvf_mouseup="$emit('hvf_mouseup', $event)" />
    </v-flex>
  </div>
</template>

<script>
import hvfImageView from "./HVFImageView";
import { mapGetters } from "vuex";
export default {
  name: "hvfMultiSidebarBlock",
  components: {hvfImageView},
  props: ["view", "index", "canvasSize", "scroll"],
  computed: {
    ...mapGetters(["hvfOrder"]),
    hvfOSImage(){
      return this.view && this.view.osImage;
    },
    hvfODImage(){
      return this.view && this.view.odImage;
    }
  },
  methods: {
    wheel(e){
      let upOrForward = e.deltaY < 0;
      let switchImages = e.shiftKey || e.ctrlKey || e.altKey;

      if (switchImages && upOrForward) this.$emit("next", this.index);
      else if (switchImages) this.$emit("prev", this.index);
      else if (upOrForward) this.$emit("scrollUp");
      else this.$emit("scrollDown");
    }
  }
}
</script>